import React from 'react';
import { Button, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../../../components/elements/HeaderClient';
import { TableInfiniteScroll } from 'app/components/elements/TableInfiniteScroll';
import { HEADER_CLIENTS, useInjection } from './hook';
import { Client } from 'types/clients';
import { TextEllipsis } from '../../../../../components/elements/TextEllipsis';
import { ClientLogo } from '../../../../Clients/conponents/ClientPhoto';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';

export const UploadPlan = () => {
  const {
    clients,
    fetchMoreData,
    hasMore,
    handleSearch,
    onSortHeader,
    searchParams,
    onClickAction
  } = useInjection();
  const { auth } = useAuth();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderDataMap = (clients: Client[]): any[] => {
    const isCanAccessRoom = auth?.role
      ? [Role.ADMIN, Role.SUPER_ADMIN].includes(auth?.role)
      : false;
    const isAllowPermission = (clientId: number) =>
      isCanAccessRoom ? true : auth?.accessibleClients?.some((client) => client.id === clientId);
    return clients.map((client) => {
      if (!isAllowPermission(client.id)) return null;
      return {
        clientName: {
          value: (
            <Stack flexDirection={'row'} alignItems={'center'} gap={'10px'}>
              {client.logo && <ClientLogo url={client.logo} alt={'logo-client'} height={20} />}
              <TextEllipsis
                onClick={() => {
                  onClickAction(`/inspection/${client.clientName}/${client.id}/location`);
                }}
                text={client.clientName}
                styles={{ textDecoration: 'underline', cursor: 'pointer', color: '#226AAA' }}
                width={'80%'}
              />
            </Stack>
          )
        },
        actions: {
          value: (
            <Stack flexDirection="row" gap={1.25}>
              <Button
                onClick={() =>
                  onClickAction(`/inspection/${client.clientName}/${client.id}/location`)
                }>
                <Typography sx={{ textDecoration: 'underline' }}>View</Typography>
              </Button>
            </Stack>
          )
        }
      };
    });
  };
  return (
    <WrapperCreatePage gap={2.5}>
      <HeaderClient
        onSearch={handleSearch}
        searchholder="Search"
        paths={[{ name: 'Inspection', onClick: () => {}, level: 999 }]}
        title={'Client'}
      />
      <Stack id={'id-table-clients'} sx={{ height: 'calc(100% - 230px)', overflow: 'scroll' }}>
        <TableInfiniteScroll
          sort={{
            field: searchParams.get('sortBy') || '',
            order: searchParams.get('order') || ''
          }}
          onSortHeader={onSortHeader}
          idElementScroll={'id-table-clients'}
          data={renderDataMap(clients)}
          handleFetchMore={fetchMoreData}
          headers={HEADER_CLIENTS}
          hasMore={hasMore}
          handleChooseRow={() => {}}
          styledTableRow={{ cursor: ' default ' }}
        />
      </Stack>
    </WrapperCreatePage>
  );
};

const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 30px 40px',
  width: '100%',
  height: '100vh'
}));
